import api from '@/api/order';

export default {
    state: {
        orderProducts: null,
    },
    mutations: {
        SET_ORDER_PRODUCTS_DATA(state, payload) {
            state.orderProducts = payload;
        },
    },
    actions: {
        fetchOrderProducts({
            commit
        }, payload) {
            let orderId = payload;
            api.getOrderProducts(orderId).then(({
                data: {
                    data: {
                        products
                    }
                },
                status
            }) => {
                if (status === 200) {
                    commit('SET_ORDER_PRODUCTS_DATA', products);
                }
            });
        }
    },
};